// src/pages/PDFViewerPage.js

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PDFViewer from '../components/players/PDFViewer';

const PDFViewerPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    
    const { fileUrl, mediaId, title } = location.state || {};
    const displayTitle = title || 'سند PDF';

    // اولویت با fileUrl (برای محصولات رایگان که آدرس عمومی دارند)
    if (fileUrl) {
        return (
            <div className="pdf-page-container min-h-screen">
                <div className="flex items-center justify-between p-4 bg-gray-800 text-white shadow-md">
                    <button 
                        onClick={() => navigate(-1)} 
                        className="flex items-center space-x-2 p-2 rounded-full hover:bg-gray-700 transition"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m15 18-6-6 6-6"/>
                        </svg>
                        <span>بازگشت</span>
                    </button>
                    <h1 className="text-xl font-bold truncate flex-1 text-center pr-24">{displayTitle}</h1>
                    <div className="w-24"></div>
                </div>
                {/* نمایش PDF با تگ embed (سریع و بدون نیاز به کتابخانه) */}
                <embed 
                    src={fileUrl} 
                    type="application/pdf" 
                    width="100%" 
                    height="90vh" 
                    className="bg-gray-200" 
                />
            </div>
        );
    }

    // اگر fileUrl وجود نداشت ولی mediaId داشت، از کامپوننت PDFViewer استفاده کن
    if (mediaId) {
        return (
            <div className="pdf-page-container min-h-screen">
                <div className="flex items-center justify-between p-4 bg-gray-800 text-white shadow-md">
                    <button 
                        onClick={() => navigate(-1)} 
                        className="flex items-center space-x-2 p-2 rounded-full hover:bg-gray-700 transition"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m15 18-6-6 6-6"/>
                        </svg>
                        <span>بازگشت</span>
                    </button>
                    <h1 className="text-xl font-bold truncate flex-1 text-center pr-24">{displayTitle}</h1>
                    <div className="w-24"></div>
                </div>
                <PDFViewer mediaId={mediaId} title={displayTitle} /> 
            </div>
        );
    }

    // اگر هیچکدام وجود نداشت، خطا نمایش بده
    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-8 text-center bg-gray-50">
            <h1 className="text-2xl font-bold text-red-600">خطا در بارگذاری PDF</h1>
            <p className="mt-2 text-gray-600">آدرس فایل معتبر نیست یا گم شده است.</p>
            <button 
                onClick={() => navigate(-1)} 
                className="mt-6 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
                بازگشت به صفحه محتوا
            </button>
        </div>
    );
};

export default PDFViewerPage;